import {RsvpStatus as RsvpStatusV2} from '@wix/ambassador-events-v2-rsvp/types'
import {RsvpStatus} from '@wix/events-types'
import {isNoResponseEnabled, isRsvpOpen, isRsvpStatusWaitlist, isRsvpStatusYes} from '@wix/wix-events-commons-statics'
import {State} from '../types/state'
import {isMember} from './current-member-details'
import {getEvent} from './event'

export const getMemberRsvp = (state: State) => state.memberRsvp.rsvp

export const getMemberRsvpId = (state: State) => getMemberRsvp(state)?.id ?? null

export const isMemberEventRsvpReady = (state: State) => state.memberRsvp.loaded

export const getMemberEventRsvpStatus = (state: State): RsvpStatus | RsvpStatusV2 => {
  const memberRSVP = getMemberRsvp(state)
  return memberRSVP && isMember(state) ? memberRSVP.status : null
}

export const isMemberRsvpExists = (state: State): boolean => getMemberEventRsvpStatus(state) !== null

export const resolveStatusTextTranslation = (state: State) => {
  const status = getMemberEventRsvpStatus(state)
  const noEnabled = isNoResponseEnabled(getEvent(state))

  if (!isMemberRsvpExists(state)) {
    return 'members.updateRsvp.message.notGoing'
  } else if (isRsvpStatusWaitlist(status)) {
    return 'members.updateRsvp.message.waitlist'
  } else if (!noEnabled || isRsvpStatusYes(status)) {
    return 'members.updateRsvp.message.going'
  } else {
    return 'members.updateRsvp.message.notGoing'
  }
}

export const resolveButtonTextTranslation = (state: State) => {
  const noEnabled = isNoResponseEnabled(getEvent(state))

  if (!noEnabled && isMemberRsvpExists(state) && !isMemberAbleToFinishRsvp(state)) {
    return 'members.updateRsvp.button-cancel'
  } else {
    return 'members.updateRsvp.button-update'
  }
}

export const isMemberAbleToFinishRsvp = (state: State) =>
  isMemberRsvpExists(state) && isRsvpStatusWaitlist(getMemberEventRsvpStatus(state)) && isRsvpOpen(getEvent(state))

export const getFormattedRsvpFullNameAndEmail = (state: State) => {
  const memberRsvp = getMemberRsvp(state)

  return {
    guestName: `${memberRsvp?.firstName ?? ''} ${memberRsvp?.lastName ?? ''}`,
    guestEmail: memberRsvp?.email ?? '',
  }
}
